import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Dropdown, Input } from '../../../components/common/Form';
import ProfileSectionPage from '../../../components/ProfileSectionPage/ProfileSectionPage';
import { useBrandContext } from '../../../contexts/BrandContext';
import { useCuisinesContext } from '../../../contexts/CuisinesContext';
import { updateBrand } from '../../../api/brand';
import './styles/_brand-profile-basic-info.scss';
import BrandProfileActions from './BrandProfileActions';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const BrandBasicInfoPage = () => {
  const { currentBrand, refreshCurrentBrand } = useBrandContext();
  const { cuisines } = useCuisinesContext();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [phone, setPhone] = useState('');
  const [cuisineID, setCuisineID] = useState('');
  const [website, setWebsite] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setName(currentBrand?.name || '');
    setEmail(currentBrand?.email || '');
    setPhone(currentBrand?.phone || '');
    setCuisineID(currentBrand?.cuisineID?.toString() || '');
    setWebsite(currentBrand?.website || '');
  }, [currentBrand]);

  const emailError = email.trim() && !EMAIL_PATTERN.test(email.trim()) ? 'Enter a valid email address.' : '';

  const handleSave = async () => {
    if (!currentBrand || isSaving || emailError) return;

    setIsSaving(true);

    try {
      await updateBrand(currentBrand.id, {
        name: name.trim(),
        email: email.trim() || null,
        phone: phone.trim() || null,
        cuisineID: cuisineID ? Number(cuisineID) : null,
        website: website.trim() || null
      });

      await refreshCurrentBrand();
      toast.success('Basic information saved successfully.');
    } catch (error) {
      console.error('Failed to save brand information:', error);
      toast.error('Failed to save basic information.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ProfileSectionPage title="BASIC INFORMATION">
      <form className="location-profile-content" onSubmit={(e) => e.preventDefault()}>
        <div className="brand-basic-info-page">
          <Input
            name="name"
            label="BRAND NAME"
            className="brand-basic-info-name-input"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
          />

          <Input
            name="email"
            type="email"
            label={
              <span>
                EMAIL ADDRESS <i>(Optional)</i>
              </span>
            }
            className="brand-basic-info-email-input"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            onBlur={() => setEmailTouched(true)}
            touched={emailTouched}
            error={emailError}
          />

          <Input
            name="phone"
            type="tel"
            label={
              <span>
                PHONE NUMBER <i>(Optional)</i>
              </span>
            }
            className="brand-basic-info-phone-input"
            value={phone}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
          />

          {cuisines?.length > 0 && (
            <Dropdown
              label="CUISINE"
              className="brand-basic-info-cuisine-select"
              onChange={(value: string) => setCuisineID(value)}
              value={cuisineID}
              values={cuisines.map((c) => ({
                label: c.name,
                value: c.cuisineID.toString()
              }))}
            />
          )}

          <Input
            name="website"
            label={
              <span>
                WEBSITE <i>(Optional)</i>
              </span>
            }
            className="brand-basic-info-website-input"
            value={website}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setWebsite(e.target.value)}
          />

          <BrandProfileActions onSave={handleSave} isSaving={isSaving} isDisabled={!!emailError} />
        </div>
      </form>
    </ProfileSectionPage>
  );
};

export default BrandBasicInfoPage;
